import { render, staticRenderFns } from "./PersonalisationListTable.vue?vue&type=template&id=5921b5cc"
import script from "./PersonalisationListTable.vue?vue&type=script&lang=ts"
export * from "./PersonalisationListTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports